import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from'./Button.module.scss';

class Button extends React.Component {
  handleClick(e) {
    e.preventDefault();

    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    const { 
      children, 
      ctaHighlight,
      disabled,
      smallButton,
      linkButton,
    } = this.props;

    // if linkButton ? buttonStyle = styles.linkButton :
    let cx = classNames.bind(styles);
    let buttonStyle = (linkButton)
      ? styles.link
      : cx({
        button: true,
        disabled: disabled,
        small: smallButton,
        cta: ctaHighlight,
      });
  
    return (
      <button
        className={buttonStyle}
        disabled={this.props.disabled || false}
        onClick={(e) => this.handleClick(e)}>
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  ctaHighlight: PropTypes.bool.isRequired,
  smallButton: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  linkButton: PropTypes.bool.isRequired,
};

Button.defaultProps = {
  ctaHighlight: true,
  disabled: false,
  smallButton: false,
  linkButton: false,
};

export default Button;
